/**
 * OrderStatusBanner Component
 *
 * Displays contextual status banners based on order status.
 */

import { XCircle, CheckCircle, Send, Package } from 'lucide-react';
import { PurchaseOrderStatus } from '@bstock/shared';

interface OrderStatusBannerProps {
  status: PurchaseOrderStatus;
}

export function OrderStatusBanner({ status }: OrderStatusBannerProps) {
  if (status === PurchaseOrderStatus.CANCELLED) {
    return (
      <div className="bg-neutral-100 border border-neutral-300 rounded-lg p-4 mb-6 flex items-center gap-3">
        <XCircle className="w-5 h-5 text-neutral-500 flex-shrink-0" />
        <span className="text-sm text-neutral-600">
          Cette commande a ete annulee.
        </span>
      </div>
    );
  }

  if (status === PurchaseOrderStatus.RECEIVED) {
    return (
      <div className="bg-success-50 border border-success-200 rounded-lg p-4 mb-6 flex items-center gap-3">
        <CheckCircle className="w-5 h-5 text-success-600 flex-shrink-0" />
        <span className="text-sm text-success-700">
          Cette commande a ete completement recue.
        </span>
      </div>
    );
  }

  if (status === PurchaseOrderStatus.SENT) {
    return (
      <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6 flex items-center gap-3">
        <Send className="w-5 h-5 text-primary-600 flex-shrink-0" />
        <span className="text-sm text-primary-700">
          Cette commande a ete envoyee au fournisseur et est en attente de reception.
        </span>
      </div>
    );
  }

  if (status === PurchaseOrderStatus.PARTIALLY_RECEIVED) {
    return (
      <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 mb-6 flex items-center gap-3">
        <Package className="w-5 h-5 text-warning-600 flex-shrink-0" />
        <span className="text-sm text-warning-700">
          Cette commande est partiellement recue. Il reste des articles a recevoir.
        </span>
      </div>
    );
  }

  // Draft or unknown status - no banner
  return null;
}
